import {createContext} from "react";

// This context stores a reference to the execution tree.
const ExecutionTreeContext = createContext();

export default ExecutionTreeContext;
